<div class="message-page-container">
  <div class="message-page-nav-bar box">
    <div class="message-page-nav-bar-title">پیام ها</div>
    <div class="message-page-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="message-page-holder">
    <ng-container *ngIf="messages">
      <div
        class="message-page-box"
        [ngClass]="{
          admin: message.sender === 'admin',
          user: message.sender === 'user'
        }"
        *ngFor="let message of messages.messages"
      >
        <div class="message-page-date">{{ getDate(message.dateTime) }}</div>
        <div class="message-page-bubble">
          <p>
            {{ message.text }}
          </p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="messages && messages.messages.length <= 1">
      <div class="message-page-box admin">
        <div class="message-page-bubble">
          <p>در انتظار پاسخ ...</p>
        </div>
      </div>
    </ng-container>
    <div
      class="message-page-vote-container"
      *ngIf="messages && messages.messages.length > 1"
    >
      <div style="width: 186px;">
        <p>این پاسخ به شما کمک کرد ؟</p>
      </div>
      <div class="message-page-vote" style="width: 120px; height: 48px; position: relative;">
        <button class="answer-box-vote-yes" (click)="vote('like')" style="left: 60px;">
          <img
            [src]="
              userReaction === 'like'
                ? 'assets/setting/like-solid.svg'
                : 'assets/setting/like.svg'
            "
            alt="" style="top: 6px; position: relative;"
          />
        </button>
        <button class="message-page-box-vote-no" (click)="vote('dislike')" style="left: 4px;">
          <img
            [src]="
              userReaction === 'dislike'
                ? 'assets/setting/dislike-solid.svg'
                : 'assets/setting/dislike.svg'
            "
            alt="" style="top: 6px; position: relative;"
          />
        </button>
      </div>
    </div>
  </div>
</div>
